module.exports = __webpack_public_path__ + "img/ecommerce-app.a7859ad7.png";